<template>
    <div>
        <section id="service">
            <div>
                <h1 class="mb-4 text-center">{{ isClientPage ? client.program_name : 'RESIDENT LIABILITY PROGRAM' }}
                </h1>
            </div>
            <div class="container services-area">
                <div class="mb-3">
                    <div class="mb-5">
                        <h2 v-if="isClientPage">WHAT IS THE {{ client.program_name }}?</h2>
                        <!--
                        <p>Under the {{ isClientPage ? `${client.program_name}, you pay $${client.program_price} per
                        month, in addition to your rental payment and we waive our right to seek reimbursement from
                        you for up to $${client.liability_limit} for damage to our property` : `Resident Liability
                        Program, you pay a nominal fee in addition to your regular rental payment and are
                        indemnified for up to a minimum amount for damage to the rental property` }} from fire,
                            smoke, explosions, water, sewer back up or falling objects when such damage is caused by the
                            negligent action or inaction of you, your occupants, or your guests.
                        </p>
                        -->
                        <template v-if="isClientPage"><p>For a small monthly fee of ${{ client.program_price }} paid in addition to your rental payment, you are relieved from your landlord liability insurance requirement.</p><p>In exchange for this fee, your landlord waives their right to seek reimbursement from the enrolled resident for up to ${{ client.liability_limit }} for damage to our property from fire, smoke, explosions, water damage including sewer back up, or falling objects when such damage is caused by the negligent action or inaction of you, your occupants, or your guests.</p></template><template v-else><p>For a small monthly fee paid in addition to your rental payment, you are relieved from your landlord liability insurance requirement.</p><p>In exchange for this fee, your landlord waives their right to seek reimbursement from the enrolled resident for up to a minimum amount for damage to our property from fire, smoke, explosions, water damage including sewer back up, or falling objects when such damage is caused by the negligent action or inaction of you, your occupants, or your guests.</p></template>
                    </div>

                    <h2>WHAT ARE THE BENEFITS?</h2>
                    <div class="mb-5">
                        <ul class="info mt-3">
                            <li>No deductible for any waived damage</li>
                            <li>No liability up to {{ isClientPage ? `$${client.liability_limit}` : 'a minimum amount'
                            }} for any waived damage</li>
                            <li>No paperwork for an insurance claim</li>
                            <li>Satisfies your liability insurance lease requirement</li>
                        </ul>
                    </div>

                    <h2>HOW MUCH DOES IT COST?</h2>
                    <div class="mb-5">
                        <p v-if="isClientPage">${{ client.program_price }} per month to be paid with your monthly rent
                        </p>
                        <p v-else>The price varies slightly depending on your property. Please check your lease addendum
                            for
                            more detail.</p>
                    </div>
                    <!--
                    <h2>WHAT IF I WOULD LIKE TO COVER MY PERSONAL PROPERTY?</h2>
                    <div class="mb-5">
                        <p>{{ isClientPage ? `${client.full_name} cares` : 'We care' }}  about your personal property and we have partnered with Worth Ave Group to offer
                            our residents pre-approved personal contents insurance.<br>
                        <span class="note">*This program is not associated or administered by ConfirmInsurance,
                            POPIC, and/or {{ isClientPage ? client.full_name : 'your property owner' }}.</span></p>
                        <p class="text-center mt-4"><a target="_blank" href="https://www.worthavegroup.com/portal/popic" class="btn btn-block btn-primary">Visit Worth Avenue Group</a></p>
                    </div>
-->
                    <h2>HOW DO I OPT-OUT OF THE PROGRAM?</h2>
                    <div v-if="isClientPage">
                        <p class="mb-2">Obtain a third-party liability insurance policy. Click the <template
                                v-if="isEntrataIntegration"><a :href="entrataIntegrationLink" class="link">Opt-Out</a></template><template v-else-if="isNewPortal"><a href="https://portal.confirminsurance.com/" class="link">Opt-Out</a></template><template v-else>
                            <inertia-link href="/opt-out" class="link">Opt-Out</inertia-link></template> button below and
                            you will be prompted to upload a copy of your policy. We will review the policy to determine
                            if it complies with the lease addendum and communicate with you regarding the approval or
                            denial.
                        </p>
                        <p class="mt-3">To comply, the policy must:</p>
                        <ul class="info mt-3">
                            <li>List all leaseholders on the policy.</li>
                            <li>Contain the insured address as stated on the lease agreement.</li>
                            <li>Cover property liability for a minimum amount of ${{ client.liability_limit }}.</li>
                            <li>Contain both start and end dates.</li>
                            <li>Add as an "Additional interest," "Interested party," or "Certificate holder": {{
                                    client.reporting_email
                            }}</li>
                            <li>Add as an “Additional interest,” “Interested party,” or “Certificate holder”: {{
                                    client.addl_int_name
                            }}, {{ client.addl_int_address }}</li>
                        </ul>
                    </div>
                    <div v-else>
                        <p>Please contact the leasing office for more information and a link to the opt-out page.</p>
                    </div>
                </div>
            </div> <!-- container -->

            <div id="opt-out" class="container mb-3 mt-5">
                <div class="row">
                    <div class="mb-5">
                        <div v-if="isClientPage" class="text-center">
                            <template v-if="isEntrataIntegration">
                                <a :href="entrataIntegrationLink"
                                    class="btn btn-success bnt-block btn-lg">
                                    Click Here To OPT-OUT
                                </a>
                            </template>
                            <template v-if="isNewPortal">
                                <a href="https://portal.confirminsurance.com/"
                                    class="btn btn-success bnt-block btn-lg">
                                    Click Here To OPT-OUT
                                </a>
                            </template>
                            <template v-else >
                                <inertia-link href="/opt-out" class="btn btn-success bnt-block btn-lg">Click Here To
                                    OPT-OUT</inertia-link>
                            </template>
                            </div>
                            <div class="text-center mt-3" v-if="isPersonalProgram">
                                <inertia-link v-if="isClientPage" href="/ppp-opt-out"
                                    class="btn btn-success bnt-block btn-lg">Opt-Out of {{ client.personal_program_name }}
                                </inertia-link>
                        </div>
                    </div>
                    <div class="blue-bg mb-3 text-center">
                        <p>The {{ isClientPage ? client.program_name : 'Resident Liability Program' }} is not insurance;
                            it is a contractual waiver of our
                            rights.</p>
                        <p>This program does not cover personal property.</p>
                        <p>Summary only, please see lease addendum for complete details.</p>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    components: {},
    layout: Layout,
    props: {
        client: Object,
        entrataIntegrationLink: String,
        isClientPage: Boolean,
        isEntrataIntegration: Boolean,
        isPersonalProgram: Boolean,
        isNewPortal: Boolean,
    },
    data() {
        return {}
    },
    watch: {},
    methods: {},
}
</script>
